<script>
	import Dispatch from '../../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'

	let mouseStart = 0

  let icons = {
    spiral: faSolarSystem,
    flash: faFire,
    twinkle: faSparkles,
  }

  // let groups = {
  //   everything: 'bg-dark-green white',
  //   left: 'bg-dark-red white',
  //   right: 'bg-dark-blue white',
  //   square: 'bg-purple white',
  // }

  const groups = Dispatch.getState('view.groups')

  const scale = Dispatch.getState('view.scale')

  const state = Dispatch.getState('view.mode')

  export let command
  export let height

  const mouseDown = Dispatch.getState('view.mouseDown')

</script>
  
  <div 
    class={'bg-dark-gray flex justify-center items-center ' + _.find($groups, group => group.id === command.lightgroup)?.style}
    style={'overflow: hidden; height: ' + height + 'px; width: ' + ($scale.windowWidth / $scale.songLength) * command.width + 'px; cursor: grab;'}
    draggable=true 
    on:click={e => {
      e.preventDefault(); e.stopPropagation()
      Dispatch.nextAction('thumb.clicked', command.id)
    }}
    on:mouseover={e => {
      if ($state === 'delete' && $mouseDown === 1) {
        Dispatch.nextAction('thumb.clicked', command.id)
      }
    }}
    on:dragend={e => {
      e.preventDefault()
      Dispatch.nextAction('position.' + command.id, e.offsetX - mouseStart)
    }} 
    on:dragstart={e => {
      mouseStart = e.offsetX
    }}
  >
    <Fa icon={icons[command.type]} />
  </div>

<style>
</style>